import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { t } from '../../../services/i18nService';

import OptionButton from './OptionButton';
import exitButtonSelector from '../../../selectors/exitButton/ExitButtonSelector';

const ExitChromeAppButtonComponent = ({ clickHandler, disabled, a11yAttributes }) => {
    return (<OptionButton
        iconClass="fa fa-unlock-alt fa-fw"
        clickHandler={clickHandler}
        title={t('options.exitChromeApp')}
        disabled={disabled}
        a11yAttributes={a11yAttributes}
    />);
};

ExitChromeAppButtonComponent.propTypes = {
    clickHandler: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    a11yAttributes: PropTypes.object,
};

const mapStateToProps = (state, ownProps) => exitButtonSelector.selectExitButtonProps(state, ownProps);
const ExitChromeAppButton = connect(mapStateToProps)(ExitChromeAppButtonComponent);
export default ExitChromeAppButton;
